import React from "react";
import { Grid } from "@material-ui/core";
import Footer from "../../components/footer.component";
import styles from "./styles.module.scss";

export const MadeInAmericaPage = () => {
  return (
    <Grid container className={styles.wrapper}>
      <img
        className={styles.image}
        src="/assets/images/madeInAmerica/made-in-america.png"
        alt="Made in America — Built to Deliver. Eurotech Seating manufactures in Maryland and California."
      />
      <Footer />
    </Grid>
  );
};
